import { type Extensions } from "@tiptap/react";
import { StarterKit } from "@tiptap/starter-kit";

export { DOT_PHRASE_ALLOWED_BODY_TAGS } from "./allowed-body-tags";

/**
 * The only document a phrase body may hold.
 *
 * Hiding a toolbar control leaves its node mounted, and a mounted node can still be reached
 * without a button. `# ` and `> ` are input rules, a typed URL autolinks, and a paste brings
 * whatever the source had. That markup renders fine in the editor, then
 * `sanitizeDotPhraseBodyHtml` drops it on save, losing text the provider watched themselves type.
 * A node that is never mounted cannot be created at all.
 */
export const PHRASE_TEXT_EXTENSIONS: Extensions = [
  StarterKit.configure({
    heading: false,
    blockquote: false,
    code: false,
    codeBlock: false,
    horizontalRule: false,
    link: false,
  }),
];
